import type { W_Order_FindOrderReportTable_VM_Row } from 'ab-api/web/order/findForOrderReportTable';

import { dollarFormatter } from '@acceligentllc/shared/utils/formatting';

const CSV_HEADER_KEYS = [
	'ID',
	'Image URL',
	'Model Number',
	'Name',
	'Category',
	'Location',
	'Department',
	'Price',
	'Quantity',
	'Total Amount',
];

export const toCSVData = (viewModels: W_Order_FindOrderReportTable_VM_Row[]) => {
	const header: string[] = [...CSV_HEADER_KEYS];

	const rows = viewModels.reduce((_acc, _order) => {
		_acc.push([
			`${_order.id}`,
			_order.imageUrl ? _order.imageUrl : '',
			_order.modelNumber,
			_order.name,
			_order.category,
			_order.location,
			_order.department,
			`${dollarFormatter.format(_order.price)}`,
			`${parseFloat(`${_order.quantity}`)}`,
			`${dollarFormatter.format(_order.totalAmount)}`,
		]);
		return _acc;
	}, [] as string[][]);

	return [header, ...rows];
};
